import { Storage } from '@capacitor/storage';

// Save refresh token to secure storage
export const saveRefreshToken = async (token) => {
  await Storage.set({ key: 'refreshToken', value: token });
};

// Get refresh token from secure storage
export const getRefreshToken = async () => {
  const { value } = await Storage.get({ key: 'refreshToken' });
  return value;
};

// Clear refresh token from secure storage
export const clearRefreshToken = async () => {
  await Storage.remove({ key: 'refreshToken' });
};
